// @ts-strict-ignore
import type { AllRouteEndpoints } from "../routeTypes";
import type { PreferenceCenterEditData } from "./types";

export const usersPreferenceCenter = "/users/preference_center";
export const usersPreferenceCenterCacheKeys: AllRouteEndpoints[] = [];

export const getNewPreferenceCenterEditData = (): PreferenceCenterEditData => ({
  name: "",
  id: null,
  status: "draft",
  type: "dnd",
  bodies: {
    landingPage: {
      html: "",
    },
    confirmationPage: {
      html: "",
    },
    redirectPage: {
      html: "",
    },
    dndJsons: null,
  },
});
